import { createContext } from 'react'

import { CancellationPolicyContextProps } from './types'

export const CancellationPolicyContext = createContext<CancellationPolicyContextProps>({
    openCancellationPolicyModal: (...any) => any,
    changeCurrentFilterModalState: false,
})
